const GET_FEATURES = 'publicador/step3Module1/GET_FEATURES';
const GET_FEATURES_COMPLETED = 'publicador/step3Module1/GET_FEATURES_COMPLETED';
const GET_FEATURES_FAILED = 'publicador/step3Module1/GET_FEATURES_FAILED';
const CHANGE_INPUT = 'publicador/step3Module1/CHANGE_INPUT';
const CHECK_FEATURE = 'publicador/step3Module1/CHECK_FEATURE';

export { GET_FEATURES, CHANGE_INPUT, CHECK_FEATURE, GET_FEATURES_COMPLETED, GET_FEATURES_FAILED };
